import React from 'react';

import { getRushAssetCatalogue } from 'api/forms';

import CatalogueContext from './CatalogueContext';

class CatalogueProvider extends React.Component {
  state = {
    catalogue: {},
    software: {},
    displays: {},
    peripherals: {},
    idsToExcludeForDescriptionSelect: [],
    idsToExcludeForDataPlanSelect: [],
    loading: true,
  };

  async componentDidMount() {
    const response = await getRushAssetCatalogue();

    const filterByCategory = (categoryName: string) =>
      response.filter(asset => [categoryName].includes(asset.category));

    const idsToExcludeByCategories = (categoriesToRemain: string[]) =>
      response
        .filter(asset => !categoriesToRemain.includes(asset.category))
        .flatMap(asset => asset.id);

    const softwareFiltered = filterByCategory('Software');
    const displaysFiltered = filterByCategory('Displays');
    const peripheralsFiltered = filterByCategory('Peripherals');

    const idsForDescriptionSelect: string[] = idsToExcludeByCategories(['Laptops', 'Tablets']);
    const idsForDataPlanSelect: string[] = idsToExcludeByCategories(['Data Plan']);

    await this.setState({
      catalogue: response,
      software: softwareFiltered,
      displays: displaysFiltered,
      peripherals: peripheralsFiltered,
      idsToExcludeForDescriptionSelect: idsForDescriptionSelect,
      idsToExcludeForDataPlanSelect: idsForDataPlanSelect,
      loading: false,
    });
  }

  render() {
    const { children } = this.props;
    const {
      catalogue,
      software,
      displays,
      peripherals,
      idsToExcludeForDescriptionSelect,
      idsToExcludeForDataPlanSelect,
      loading,
    } = this.state;

    return (
      <CatalogueContext.Provider
        value={{
          catalogue,
          software,
          displays,
          peripherals,
          idsToExcludeForDescriptionSelect,
          idsToExcludeForDataPlanSelect,
          loading,
        }}
      >
        {children}
      </CatalogueContext.Provider>
    );
  }
}

export default CatalogueProvider;
